export const SEASON_DIVISION_INFO_QUERY_KEY = 'SEASON_DIVISION_INFO_QUERY_KEY';
